import { Injectable } from '@angular/core';

@Injectable()
export class ErrorService {
  public isErrorVisible: boolean = false;
  public errorMessage: string = '';

  constructor() {}

  openErrorPopup(errorMessage: string) {
    this.errorMessage = errorMessage;
    this.isErrorVisible = true;
  }

  closeErrorPopup() {
    // get element
    const el = document.getElementById('box');
    // create event
    if (el) {
      el.dispatchEvent(
        new CustomEvent('logoutAfterClose', {
          bubbles: true,
          detail: {
            name: 'logoutAfterClose',
          },
        })
      );
    }

    this.errorMessage = '';
    this.isErrorVisible = false;
  }
}
